<section *ngIf="withExternalBar">
</section>
<app-layout></app-layout>
